import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

/**
 * Google Analytics (GA4) loader. Only does anything when
 * environment.gaMeasurementId is set, so it runs in production and stays off in
 * dev/staging/test. Loads gtag.js on demand and, because GA4's automatic
 * page_view fires only on the initial load, emits a page_view on every Angular
 * route change so SPA navigations are counted.
 */
@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    private initialised = false;

    constructor(private router: Router) {}

    init(): void {
        const id = environment.gaMeasurementId;
        // The demo build never loads analytics, whatever the environment says.
        if (!id || (environment as { demo?: boolean }).demo || this.initialised) {
            return;
        }
        this.initialised = true;

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        document.head.appendChild(script);

        const w = window as any;
        w.dataLayer = w.dataLayer || [];
        const gtag = (...args: any[]): void => {
            w.dataLayer.push(args);
        };
        w.gtag = gtag;
        gtag('js', new Date());
        // send_page_view:false — the initial view and every route change are sent
        // manually below so single-page navigations register.
        gtag('config', id, { send_page_view: false });

        this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(e => {
            gtag('event', 'page_view', {
                page_path: e.urlAfterRedirects,
                page_location: window.location.href,
                page_title: document.title,
            });
        });
    }
}
